import SessionStorage from "sessionstorage";
import axios from "axios";
import {APIHOST, MOMENT_API_DATE_FORMAT} from "@/settings";
import _ from "underscore";
import {jsonDataToExcel} from "@/js/XLSX";
import PrintJs from "print-js";
import Moment from "moment";

class ReturnInvoiceService {
    getInfo(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${APIHOST}/api/ReturnInvoiceInfo`, {
            params: {
                id: id
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    printPdf(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        const promise = axios.get(`${APIHOST}/api/ReturnInvoicePdf`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            },
            params: {id: id}
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            PrintJs(url);
        });

        return promise;
    }


    getAllbox({sortBy, sortDesc, skip, limit, search, start, end, branch, signDate, supplier, isExecutorApproved, isCustomerApproved, order,statuses}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ReturnInvoiceAllBox`, {
            params: {
                sortBy: sortBy,
                desc: sortDesc,
                skip: skip,
                limit: limit,
                q: search,
                start: start ? start.format(MOMENT_API_DATE_FORMAT) : null,
                end: end ? end.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch ? branch : null,
                signDate: signDate ? signDate.format(MOMENT_API_DATE_FORMAT) : null,
                supplier: supplier ? supplier : null,
                isExecutorApproved: typeof (isExecutorApproved) === 'boolean' ? isExecutorApproved : null,
                isCustomerApproved: typeof (isCustomerApproved) === 'boolean' ? isCustomerApproved : null,
                order: typeof (order) === 'number' ? order : null,
                statuses: statuses
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    delete(returnInvoiceId) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.delete(`${APIHOST}/api/ReturnInvoiceInfo`, {
            params: {
                id: returnInvoiceId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        })
    }

    register(data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.post(`${APIHOST}/api/RegisterReturnInvoice`, data, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getExecutorLastInfo() {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ExecutorLastReturnInvoiceInfo`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    downloadExcelSingle(id) {
        return new Promise((resolve, reject) => {
            this.getInfo(id)
                .then(response => {
                    let invoice = {
                        id: response.data.Id,
                        orderId: response.data.OrderId,
                        orderNumber: response.data.OrderNumber,
                        orderReturnDate: response.data.OrderReturnDate ? Moment(response.data.OrderReturnDate).format('YYYY.MM.DD') : null,
                        orderReturnNumber: response.data.OrderReturnNumber,

                        number: response.data.Number,
                        date: Moment(response.data.Date).format('YYYY.MM.DD'),

                        contractNumber: response.data.ContractNumber,
                        contractDate: response.data.ContractDate ? Moment(response.data.ContractDate).format('YYYY.MM.DD') : null,

                        customer: {
                            inn: response.data.CustomerDetail.Inn,
                            name: response.data.CustomerDetail.Name,
                            address: response.data.CustomerDetail.Address,
                            phone: response.data.CustomerDetail.Phone,
                            bankAccount: response.data.CustomerDetail.BankAccountNumber,
                            bankName: response.data.CustomerDetail.BankName,
                            bankMfo: response.data.CustomerDetail.BankMfo,
                            oked: response.data.CustomerDetail.Oked,
                            okonx: response.data.CustomerDetail.Okonx
                        },
                        executor: {
                            inn: response.data.ExecutorDetail.Inn,
                            name: response.data.ExecutorDetail.Name,
                            address: response.data.ExecutorDetail.Address,
                            phone: response.data.ExecutorDetail.Phone,
                            bankAccount: response.data.ExecutorDetail.BankAccountNumber,
                            bankName: response.data.ExecutorDetail.BankName,
                            bankMfo: response.data.ExecutorDetail.BankMfo,
                            oked: response.data.ExecutorDetail.Oked,
                            okonx: response.data.ExecutorDetail.Okonx
                        },
                        total: response.data.Total,
                        totalInWord: response.data.TotalInWords,
                        executorDirector: response.data.ExecutorDirector,
                        executorAccountant: response.data.ExecutorAcccountant,
                        executorReleaser: response.data.ExecutorReleaser,
                        customerProxyNumber: response.data.CustomerProxyNumber,
                        customerProxyDate: response.data.CustomerProxyDate ? Moment(response.data.CustomerProxyDate).format('YYYY.MM.DD') : null,
                        customerProxyName: response.data.CustomerProxyName,

                        createdOn: Moment(response.data.CreatedOn).format('YYYY.MM.DD'),
                        isCustomerApproved: response.data.IsCustomerApproved,
                        customerApprovedOn: response.data.CustomerApprovedOn ? Moment(response.data.CustomerApprovedOn) : null,
                        isExecutorApproved: response.data.IsExecutorApproved,
                        executorApprovedOn: response.data.ExecutorApprovedOn ? Moment(response.data.ExecutorApprovedOn) : null,

                        items: _.map(response.data.Items, i => {
                            return {
                                id: i.id,
                                product: i.Product,
                                measurement: i.Measurement,
                                price: i.Price,
                                quantity: i.Quantity,
                                total: i.Total,
                                exciseTaxRate: i.ExciseTaxRate,
                                exciseTaxValue: i.ExciseTaxValue,
                                ndsRate: i.NdsRate,
                                ndsValue: i.NdsValue,
                                totalWithNds: i.TotalWithNds
                            };
                        }),

                        referenceNumber: response.data.CorrectNumber,
                        referenceDate: response.data.CorrectDate ? Moment(response.data.CorrectDate).format('YYYY.MM.DD') : null,
                    };
                    let invoiceData = _.map(invoice.items, function (item) {
                        return {
                            'Номер': invoice.number,
                            'Дата': invoice.date,

                            'Номер заказа': invoice.orderNumber,
                            'Дата возвр. заказа': invoice.orderReturnDate,
                            'Номер возвр. заказа': invoice.orderReturnNumber,

                            'Заказчик': invoice.customer.name,
                            'ИНН заказчика': invoice.customer.inn,


                            'Поставщик': invoice.executor.name,
                            'ИНН поставщика': invoice.executor.inn,

                            'Сумма': invoice.total,
                            'Сумма прописью': invoice.totalInWord,

                            'Руководитель предприятия': invoice.executorDirector,
                            'Главный бухгалтер': invoice.executorAccountant,
                            'Товар отпустил': invoice.executorReleaser,
                            'По доверенности №': invoice.customerProxyNumber,
                            'Дата доверенности': invoice.customerProxyDate,
                            'ФИО получателя': invoice.customerProxyName,

                            'Одобрен заказчик': invoice.isCustomerApproved ? 'Да' : 'Нет',
                            'Дата одобрен заказчик': invoice.customerApprovedOn,

                            'Одобрен поставщик': invoice.isExecutorApproved ? 'Да' : 'Нет',
                            'Дата одобрен поставщик': invoice.executorApprovedOn,

                            'Номер дополнительный счету-фактура': invoice.referenceNumber,
                            'Дата дополнительный счету-фактура': invoice.referenceDate,

                            'Наименования товара': item.product,
                            'Ед. изм.': item.measurement,
                            'Количество': item.quantity,
                            'Цена за единицу': item.price,
                            'Стоимость': item.total,
                            'Акцизный налог': item.ndsRate,
                            'НДС': item.ndsValue,
                            'Стоимость с учётом НДС': item.totalWithNds,
                        }
                    });

                    jsonDataToExcel(invoiceData);

                    resolve()
                }, reject)
        })
    }

    downloadExcelAll(params, onEachInvoiceInfoComplete) {
        return new Promise((resolve, reject) => {
            this.getAllbox(params)
                .then(response => {
                    let invoicesList = _.map(response.data.Records, function (invoice, index) {
                        return {
                            rowNumber: index + 1,
                            id: invoice.Id,

                            orderId: invoice.OrderId,
                            orderNumber: invoice.OrderNumber,
                            orderReturnDate: invoice.OrderReturnDate ? Moment(invoice.OrderReturnDate) : null,
                            orderReturnNumber: invoice.OrderReturnNumber,

                            number: invoice.Number,
                            date: Moment(invoice.Date),

                            customer: {
                                inn: invoice.CustomerDetail.Inn,
                                name: invoice.CustomerDetail.Name,
                                address: invoice.CustomerDetail.Address,
                                phone: invoice.CustomerDetail.Phone,
                                bankAccount: invoice.CustomerDetail.BankAccountNumber,
                                bankName: invoice.CustomerDetail.BankName,
                                bankMfo: invoice.CustomerDetail.BankMfo,
                                oked: invoice.CustomerDetail.Oked,
                                okonx: invoice.CustomerDetail.Okonx
                            },
                            executor: {
                                inn: invoice.ExecutorDetail.Inn,
                                name: invoice.ExecutorDetail.Name,
                                address: invoice.ExecutorDetail.Address,
                                phone: invoice.ExecutorDetail.Phone,
                                bankAccount: invoice.ExecutorDetail.BankAccountNumber,
                                bankName: invoice.ExecutorDetail.BankName,
                                bankMfo: invoice.ExecutorDetail.BankMfo,
                                oked: invoice.ExecutorDetail.Oked,
                                okonx: invoice.ExecutorDetail.Okonx
                            },

                            total: invoice.Total,
                            totalInWord: invoice.TotalInWords,

                            executorDirector: invoice.ExecutorDirector,
                            executorAccountant: invoice.ExecutorAcccountant,
                            executorReleaser: invoice.ExecutorReleaser,

                            customerProxyNumber: invoice.CustomerProxyNumber,
                            customerProxyDate: invoice.CustomerProxyDate ? Moment(invoice.CustomerProxyDate) : null,
                            customerProxyName: invoice.CustomerProxyName,

                            createdOn: Moment(invoice.CreatedOn),

                            isCustomerApproved: invoice.IsCustomerApproved,
                            customerApprovedOn: invoice.CustomerApprovedOn ? Moment(invoice.CustomerApprovedOn) : null,
                            isExecutorApproved: invoice.IsExecutorApproved,
                            executorApprovedOn: invoice.ExecutorApprovedOn ? Moment(invoice.ExecutorApprovedOn) : null,

                            referenceNumber: invoice.CorrectNumber,
                            referenceDate: invoice.CorrectDate,
                        };
                    });

                    let dataExcel = _.map(invoicesList, function (invoice) {
                        if (typeof onEachInvoiceInfoComplete === "function")
                            onEachInvoiceInfoComplete()
                        return {
                            'Номер': invoice.number,
                            'Дата': invoice.date ? invoice.date.format('YYYY.MM.DD') : '',

                            'Номер заказа': invoice.orderNumber,
                            'Дата возвр. заказа': invoice.orderReturnDate ? invoice.orderReturnDate.format('YYYY.MM.DD') : '',
                            'Номер возвр. заказа': invoice.orderReturnNumber,

                            'Заказчик': invoice.customer.name,
                            'ИНН заказчика': invoice.customer.inn,

                            'Поставщик': invoice.executor.name,
                            'ИНН поставщика': invoice.executor.inn,

                            'Сумма': invoice.total,
                            'Сумма прописью': invoice.totalInWords,

                            'Руководитель предприятия': invoice.executorDirector,
                            'Главный бухгалтер': invoice.executorAccountant,
                            'Товар отпустил': invoice.executorReleaser,
                            'По доверенности №': invoice.customerProxyNumber,
                            'Дата доверенности': invoice.customerProxyDate ? invoice.customerProxyDate.format('YYYY.MM.DD') : '',
                            'ФИО получателя': invoice.customerProxyName,

                            'Одобрен заказчик': invoice.isCustomerApproved ? 'Да' : 'Нет',
                            'Дата одобрен заказчик': invoice.customerApprovedOn ? invoice.customerApprovedOn.format('YYYY.MM.DD') : '',

                            'Одобрен поставщик': invoice.isExecutorApproved ? 'Да' : 'Нет',
                            'Дата одобрен поставщик': invoice.executorApprovedOn ? invoice.executorApprovedOn.format('YYYY.MM.DD') : '',

                            'Номер дополнительный счету-фактура': invoice.referenceNumber,
                            'Дата дополнительный счету-фактура': invoice.referenceDate,
                        }
                    });
                    jsonDataToExcel(dataExcel);
                    resolve()
                }, reject)
        })
    }

    downloadExcelAllWithItems(params, onEachInvoiceInfoComplete) {
        this.getAllbox(params).then(response => {
            const loadReturnInvoicePromises = []
            _.each(response.data.Records, returnInvoice => {

                loadReturnInvoicePromises.push(this.getInfo(returnInvoice.Id).finally(() => {
                    if (typeof onEachInvoiceInfoComplete === "function")
                        onEachInvoiceInfoComplete()
                }))
            })

            Promise.all(loadReturnInvoicePromises).then(loadReturnInvoiceResults => {
                const dataExcel = []
                _.map(loadReturnInvoiceResults, invoice => {
                    _.each(invoice.data.Items, item => {
                        dataExcel.push({
                            'Номер': invoice.data.Number,
                            'Дата': invoice.data.Date ? Moment(invoice.data.Date).format('YYYY.MM.DD') : '',

                            'Номер заказа': invoice.data.OrderNumber,
                            'Дата возвр. заказа': invoice.data.OrderReturnDate ? Moment(invoice.data.OrderReturnDate).format('YYYY.MM.DD') : '',
                            'Номер возвр. заказа': invoice.data.OrderReturnNumber,

                            'Заказчик': invoice.data.CustomerDetail.Name,
                            'ИНН заказчика': invoice.data.CustomerDetail.Inn,
                            'Пункт отгрузки': invoice.data.ReturnShipment.DeliveryAddress.trim(),

                            'Поставщик': invoice.data.ExecutorDetail.Name,
                            'ИНН поставщика': invoice.data.ExecutorDetail.Inn,

                            'Сумма': invoice.data.Total,
                            'Сумма прописью': invoice.data.TotalInWords,

                            'Руководитель предприятия': invoice.data.ExecutorDirector,
                            'Главный бухгалтер': invoice.data.ExecutorAcccountant,
                            'Товар отпустил': invoice.data.ExecutorReleaser,
                            'По доверенности №': invoice.data.CustomerProxyNumber,
                            'Дата доверенности': invoice.data.CustomerProxyDate ? Moment(invoice.data.CustomerProxyDate).format('YYYY.MM.DD') : '',
                            'ФИО получателя': invoice.data.CustomerProxyName,

                            'Одобрен заказчик': invoice.data.IsCustomerApproved ? 'Да' : 'Нет',
                            'Дата одобрен заказчик': invoice.data.CustomerApprovedOn ? Moment(invoice.data.CustomerApprovedOn).format('YYYY.MM.DD') : '',

                            'Одобрен поставщик': invoice.data.IsExecutorApproved ? 'Да' : 'Нет',
                            'Дата одобрен поставщик': invoice.data.ExecutorApprovedOn ? Moment(invoice.data.ExecutorApprovedOn).format('YYYY.MM.DD') : '',

                            'Номер дополнительный счету-фактура': invoice.data.CorrectNumber,
                            'Дата дополнительный счету-фактура': invoice.data.CorrectDate,
                            'Товар': item.Product,
                            'Ед.изм': item.Measurement,
                            'Количество': item.Quantity,
                            'Цена за единицу': item.Price,
                            'Стоимость': item.Total,
                            'НДС ставка': item.NdsRate,
                            'НДС сумма': item.NdsValue,
                            'Сумма с НДС': item.TotalWithNds

                        })

                    })
                })
                jsonDataToExcel(dataExcel, "Реестр возвратные счёт-фактуры.xlsx");
            })

        }).catch(error => {
            window.console.log(error)
        })
    }
}

export default new ReturnInvoiceService()
